import { Editor, useEditorState } from '@tiptap/react'
import { Button, Tooltip } from 'antd'
import { Code } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

type Props = {
  editor: Editor
}

export const CodeBlockButton = ({ editor }: Props) => {
  const { t } = useTranslation()

  const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isCodeBlock: ctx.editor.isActive('codeBlock') ?? false
      }
    }
  })

  const onToggleCodeBlock = () => {
    editor.chain().focus().toggleCodeBlock().run()
  }

  return (
    <Tooltip title={t('editor.code_block')}>
      <Button
        icon={<Code size={14} />}
        onClick={onToggleCodeBlock}
        type={editorState.isCodeBlock ? 'primary' : 'default'}
      />
    </Tooltip>
  )
}
